import { useEffect, useRef, useState } from "react";
import methodModel from "../../methods/methods";
import SelectDropdown from "../SelectDropdown";
// import "./style.scss";
import ReactQuill from 'react-quill';
import PhoneInput from "react-phone-input-2";
export default function FormControl({
  name,
  id = "",
  valueType = "string",
  onInputChange = (e: any) => { },
  inputValue = "",
  displayValue = "name",
  placeholder = "",
  type = "text",
  options = [],
  error,
  label,
  required = false,
  onChange = () => { },
  maxlength = "",
  minlength = "",
  min = "",
  className = "",
  value,
  disabled = false,
  theme = "",
  autoComplete = "off",
  onkeyDown = (e: any) => { },
}: any) {
  const [text, setText] = useState("");

  const add = () => {
    let arr = value || [];
    if (text) {
      arr.push(text);
    }
    onChange(arr);
    setText("");
  };

  const remove = (i: any) => {
    let arr = value || [];
    arr = arr.filter((itm: any, index: any) => index != i);
    onChange(arr);
  };

  const addItem = (v: any) => {
    let arr = value || [];
    let ext = arr?.find((itm: any) => itm == v);

    if (ext) {
      arr = arr.filter((itm: any) => itm != v);
    } else {
      arr.push(v);
    }

    onChange(arr);
  };

  const [editorValue, setEditorValue] = useState("");
  const quillRef = useRef(null);

  useEffect(() => {
    if(type === "editor"){
      setEditorValue(value)
    }
  }, [value])

  const handleEditorChange = (content: any, delta: any, source: any, editor: any) => {
    const quillEditor = quillRef?.current?.getEditor();
    if (source === "user") {
      if (maxlength && quillEditor?.getText()?.length > maxlength) {
        const truncatedContent = quillEditor?.getText(0, maxlength);
        setEditorValue(truncatedContent);
        onChange(truncatedContent);
      } else {
        setEditorValue(content);
        onChange(content);
      }
    }
  };

  return (
    <>
      <div className="formWrapper relative w-full">
        {label ? (
          <>
            <label className="text-sm mb-2 block">
              {label}{" "}
              {required ? (
                <>
                  <span className="text-red-600">*</span>
                </>
              ) : (
                <></>
              )}
            </label>
          </>
        ) : (
          <></>
        )}
        {type == "select" ? (
          <SelectDropdown
            id={`statusDropdown_${id}`}
            displayValue={displayValue}
            className={className}
            valueType={valueType}
            onInputChange={onInputChange}
            inputValue={inputValue}
            placeholder={placeholder}
            intialValue={value || ""}
            name={name}
            theme={theme}
            result={(e: any) => {
              onChange(e.value);
            }}
            options={options}
            disabled={disabled}
          />
        ) : type == "phone" ? (
          <>
            <PhoneInput
              country={"us"}
              value={value}
              enableSearch={true}
              onChange={(e) => onChange(e)}
              disabled={disabled}
              inputClass={className}
              containerClass={className}
              countryCodeEditable={true}
            />
          </>
        ) : type == "number" ? (
          <input
            type="text"
            name={name}
            className={`relative bg-[#f9f9f9] w-full rounded-md h-10 text-[14px] text-[#333] overflow-hidden px-2 border border-[#00000036] ${className}`}
            required={required}
            placeholder={placeholder}
            value={value || ""}
            maxLength={maxlength}
            minLength={minlength}
            min={min}
            disabled={disabled}
            autoComplete={autoComplete}
            onChange={(e) => onChange(methodModel.isNumber(e))}
          />
        ) : type == "longitude" ? (
          <input
            type="text"
            name={name}
            className={`relative bg-[#f9f9f9] w-full rounded-md h-10 text-[14px] text-[#333] overflow-hidden px-2 border border-[#00000036] ${className}`}
            required={required}
            placeholder={placeholder}
            value={value || ""}
            maxLength={13}
            minLength={minlength}
            min={min}
            disabled={disabled}
            autoComplete={autoComplete}
            onChange={(e) => onChange(methodModel.isLongitudeValid(e))}
          />
        ) : type == "latitude" ? (
          <input
            type="text"
            name={name}
            className={`relative bg-[#f9f9f9] w-full rounded-md h-10 text-[14px] text-[#333] overflow-hidden px-2 border border-[#00000036] ${className}`}
            required={required}
            placeholder={placeholder}
            value={value || ""}
            maxLength={12}
            minLength={minlength}
            min={min}
            disabled={disabled}
            autoComplete={autoComplete}
            onChange={(e) => onChange(methodModel.isLatitudeValid(e))}
          />
        ) : type == "badge" ? (
          <>
            <div className="flex">
              <input
                type="text"
                className="relative border border-[#00000036] bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden px-3"
                placeholder={placeholder}
                value={text}
                disabled={disabled}
                autoComplete={autoComplete}
                onChange={(e) => setText(e.target.value)}
              />
              <button
                type="button"
                className="btn btn-primary ml-2"
                disabled={disabled}
                onClick={add}
              >
                Add
              </button>
            </div>
            <div className="">
              {value?.map((itm: any, i: any) => {
                return (
                  <span className="badge badge-primary m-1">
                    {itm}
                    <i
                      className="fa fa-times ml-1"
                      onClick={() => remove(i)}
                    ></i>
                  </span>
                );
              })}
            </div>
          </>
        ) : type == "radio" ? (
          <>
            <div className="flex items-center gap-x-4 mt-3">
              {options.map((itm: any) => {
                return (
                  <div className="">
                    {" "}
                    <label className="border border-[#00000036] px-6 py-2 rounded-lg flex cursor-pointer">
                      <input
                        type="radio"
                        checked={value == itm.id ? true : false}
                        onChange={(e) => onChange(itm.id)}
                        className="mr-2"
                        name={name}
                        autoComplete={autoComplete}
                        disabled={disabled}
                      />
                      {itm.name}
                    </label>
                  </div>
                );
              })}
            </div>
          </>
        ) : type == 'textarea' ? <>
          <textarea
            name={name}
            className="relative bg-[#f9f9f9] text-[14px] text-[#333] border border-[#00000036] w-full h-[150px] flex items-center gap-2 overflow-hidden px-3 pt-2"
            required={required}
            placeholder={placeholder}
            value={value || ""}
            maxLength={maxlength}
            minLength={minlength}
            disabled={disabled}
            autoComplete={autoComplete}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            onKeyDown={onkeyDown}
          />
        </> : type == "editor" ? (
          <>
            {/* <ReactQuill theme="snow" value={value} readOnly={disabled} onChange={onChange} className={className} /> */}
            <ReactQuill
              theme="snow"
              value={editorValue}
              onChange={handleEditorChange}
              readOnly={disabled}
              className={className}
              ref={quillRef}
            />
          </>
        ) : type == "checkbox" ? (
          <>
            {options.map((itm: any) => {
              return (
                <label className="flex">
                  <input
                    type="checkbox"
                    checked={value?.includes(itm.id) ? true : false}
                    onChange={(e) => addItem(itm.id)}
                    className="mr-2"
                    autoComplete={autoComplete}
                  />
                  {itm.name}
                </label>
              );
            })}
          </>
        ) : (
          <input
            type={type}
            name={name}
            className={`relative bg-[#f9f9f9] w-full rounded-md h-10 text-[14px] text-[#333] overflow-hidden px-2 border border-[#00000036] ${className}`}
            required={required}
            placeholder={placeholder}
            value={value || ""}
            maxLength={maxlength}
            minLength={minlength}
            min={min}
            disabled={disabled}
            autoComplete={autoComplete}
            onChange={(e) => {
              onChange(e.target.value);
            }}
            onKeyDown={onkeyDown}
          />
        )}
        {error ? (
          <>
            <div className="text-danger small mt-1">{error}</div>
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
}
